import { AnimatePresence, motion } from 'framer-motion';
import React, { ReactNode } from 'react';

interface Props {
  isVisible: boolean;
  children: ReactNode;
}

export const FadeInOut = ({ isVisible, children }: Props) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        key="fade-in-out"
        animate={{
          display: 'block',
          opacity: 1,
        }}
        exit={{ display: 'none', opacity: 0 }}
        initial={{ display: 'none', opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
);
